export default __webpack_public_path__ + "static/media/resto.559192a0.jpg";